export const REQUEST_PASSWORD_RESET = "REQUEST_PASSWORD_RESET";
export const REQUEST_PASSWORD_RESET_SUCCESS = "REQUEST_PASSWORD_RESET_SUCCESS";
export const REQUEST_PASSWORD_RESET_ERROR = "REQUEST_PASSWORD_RESET_ERROR";

export const VERIFY_MFA_CODE = "VERIFY_MFA_CODE";
export const VERIFY_MFA_CODE_SUCCESS = "VERIFY_MFA_CODE_SUCCESS";
export const VERIFY_MFA_CODE_ERROR = "VERIFY_MFA_CODE_ERROR";

export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";
